"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lit_element_1 = require("lit-element");
const repeat_1 = require("lit-html/directives/repeat");
const button_group_css_1 = tslib_1.__importDefault(require("./button-group-css"));
let ZenButtonGroup = class ZenButtonGroup extends lit_element_1.LitElement {
    constructor() {
        super(...arguments);
        this.buttons = [];
        this.size = 'main';
    }
    render() {
        return lit_element_1.html `
      ${button_group_css_1.default}
      ${repeat_1.repeat(this.buttons, () => { }, (b) => lit_element_1.html `
            <zen-button
              .size="${b.size || this.size}"
              .icon="${b.icon}"
              .iconright="${b.iconright}"
              .hollow="${b.hollow}"
              .color="${b.color}"
              .disabled="${b.disabled}"
              .loading="${b.loading}"
              @click="${b.onclick}"
              >${b.text}</zen-button
            >
          `)}
    `;
    }
};
tslib_1.__decorate([
    lit_element_1.property()
], ZenButtonGroup.prototype, "buttons", void 0);
tslib_1.__decorate([
    lit_element_1.property()
], ZenButtonGroup.prototype, "size", void 0);
ZenButtonGroup = tslib_1.__decorate([
    lit_element_1.customElement('zen-button-group')
], ZenButtonGroup);
exports.ZenButtonGroup = ZenButtonGroup;
